import React from "react";

import ContextProvider from "../provider/ContextProvider";

const NotFound = ({ children }) => (
	<ContextProvider>{children}</ContextProvider>
);

export default NotFound;
